import { i18n } from '@lingui/core'

export type ApiErrorBody = {
  code?: string | number
  context?: Record<string, unknown> | null
  message?: string
}

const MESSAGE_BY_CODE: Record<string, () => string> = {
  CARD_PRODUCT_LIMIT_REACHED: () =>
    i18n._('error.api.cardProductLimitReached', undefined, {
      message:
        'You already have this card. Check the Cards section — it is there.',
    }),
  CARD_ISSUANCE_NOT_ELIGIBLE: () =>
    i18n._('error.api.cardIssuanceNotEligible', undefined, {
      message: 'This card is not available on your account yet.',
    }),
  CARD_PRODUCT_CONTEXT_NOT_ADMITTED: () =>
    i18n._('error.api.cardProductContextNotAdmitted', undefined, {
      message: 'This card cannot be issued on your account.',
    }),
  LOCK_CONTENTION: () =>
    i18n._('error.api.lockContention', undefined, {
      message: 'Another change is still running. Try again in a moment.',
    }),
  NO_ACTIVE_CREDIT_ACCESS: () =>
    i18n._('error.api.noActiveCreditAccess', undefined, {
      message: 'Your account is not active yet, so this is not available.',
    }),
}

export const getApiErrorMessage = (body?: ApiErrorBody | null) => {
  if (body?.message) {
    return body.message
  }

  return typeof body?.code === 'string'
    ? MESSAGE_BY_CODE[body.code]?.()
    : undefined
}
